import { maklersService } from "../../../service/maklersService";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import BSpinner from "../../../components/spinners/BSpinner";
import EditMaklersForm from "../../../forms/EditMaklersForm";

export default function MaklersEditPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [responseErrors, setResponseErrors] = useState([]);
  const { id } = useParams();
  const [broker, setBroker] = useState({});
  const history = useHistory();

  useEffect(() => {
    setIsLoading(true);
    setResponseErrors([])

    maklersService
      .getMaklerById(id)
      .then((res) => setBroker(res.data))
      .catch((err) => {
        if (err.response.data) {
          setResponseErrors(err.response.data);
        }
      })
      .finally(() => setIsLoading(false));
  }, [id]);

  const handleSubmit = (data) => {
    setIsLoading(true);
    setResponseErrors([])

    maklersService
      .updateMakler(id, data)
      .then(() => {
        history.push(`/brokers/${id}`);
      })
      .catch((err) => {
        if (err.response.data) {
          setResponseErrors(err.response.data);
        }
      })
      .finally((_) => {
        setIsLoading(false);
      });
  };

  const joinBrokerZipCode = (broker) => {
    broker["zipCodes"] = broker.zipCodes ? broker.zipCodes.join(", ") : "";
    return broker;
  };

  if (isLoading) {
    return <BSpinner />;
  }

  return (
    <div className="m-6 bg-white border-gray-400 rounded shadow-md">
      <EditMaklersForm
        isNew={false}
        onSubmit={handleSubmit}
        preloadedData={broker}
        btnText="Speichern"
        responseErrors={responseErrors}
      />
    </div>
  );
}
